var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import cx from 'classnames';
import makeStyles from '@mui/styles/makeStyles';
import Tooltip from '@mui/material/Tooltip';

var useStyles = makeStyles(function (theme) {
  return {
    tooltip: {
      fontSize: 12,
      boxShadow: theme.shadows[2]
    },
    warningTooltip: {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.getContrastText(theme.palette.warning.main)
    },
    lightTooltip: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.getContrastText(theme.palette.common.white)
    },
    darkTooltip: {
      backgroundColor: '#616161',
      color: theme.palette.getContrastText(theme.palette.common.black),
      '& a': {
        color: theme.palette.primary.light,
        textDecoration: 'none',
        '&:hover': {
          color: theme.palette.primary.light,
          textDecoration: 'underline'
        }
      }
    },
    popper: {
      opacity: 1
    }
  };
});

var CustomTooltip = function CustomTooltip(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === undefined ? 'dark' : _ref$variant,
      props = _objectWithoutProperties(_ref, ['children', 'variant']);

  var classes = useStyles();
  return React.createElement(
    Tooltip,
    _extends({
      enterNextDelay: 100,
      classes: {
        popper: classes.popper,
        tooltip: cx(R.prop(variant + 'Tooltip')(classes), classes.tooltip)
      }
    }, props),
    children
  );
};

CustomTooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  variant: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
} : {};

export default CustomTooltip;